<script>
const textFieldProps = {
  hideDetails: true,
};

const textFieldLikeProps = {
  ...textFieldProps,
  color: 'inherit',
};

const additionalProps =  {
  'v-text-field': textFieldProps,
  'text-field-like': textFieldLikeProps,
  'hds-id-field': textFieldLikeProps,
  'local-id-field': textFieldLikeProps,
  'owner-field': textFieldLikeProps,
  'dictionary-name-field': textFieldLikeProps,
};

export default {
  name: "MenuInline",
  render(h) {
    const inputVNode = Array.isArray(this.$slots.default) && this.$slots.default[0];
    if(!inputVNode) {
      return null;
    }
    const compOptions = inputVNode.componentOptions;
    compOptions.propsData = {
      ...compOptions.propsData,
      ...additionalProps[compOptions.tag],
      dense: true,
      hideDetails: true,
    };
    return h('div', {
      class: {
        'menu-inline': true,
      }
    }, [inputVNode]);
  },
}
</script>

<style lang="scss" scoped>
.menu-inline ::v-deep {
  .v-input {
    font-size: 14px;
  }
}
</style>
